import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { PartnerDashboardRoutingModule } from './partner-dashboard-routing.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProgramElementComponent } from './components/program-element/program-element.component';
import { StarRatingComponent } from './common/star-rating/star-rating.component';
import { CircularProgressComponent } from './common/circular-progress/circular-progress.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressBarComponent } from './common/progress-bar/progress-bar.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TablePaginationComponent } from './common/table-pagination/table-pagination.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { LearnersComponent } from './components/learners/learners.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { FaqComponent } from './components/faq/faq.component';
import { AccordionModule, AccordionConfig } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {SidebarModule} from '../player/sidebar/sidebar.module';

@NgModule({
  declarations: [DashboardComponent, ProgramElementComponent, StarRatingComponent, CircularProgressComponent, ProgressBarComponent, TablePaginationComponent, LearnersComponent, FaqComponent],
  imports: [
    CommonModule,
    PartnerDashboardRoutingModule,
    NgbModule,
    ProgressbarModule,
    NgCircleProgressModule,
    NgxPaginationModule,
    IvyCarouselModule,
    AccordionModule,
    FormsModule,
    SharedModule,
    SidebarModule
  ],
  exports: [
    DashboardComponent,
    ProgramElementComponent,
    StarRatingComponent,
    CircularProgressComponent,
    LearnersComponent,
    FaqComponent
  ],
  providers: [
    { provide: AccordionConfig, useValue: { closeOthers: true } },
  DatePipe],
  bootstrap: [
    DashboardComponent,
    ProgramElementComponent,
    StarRatingComponent,
    FaqComponent],
})
export class PartnerDashboardModule { }
